import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'cookie-consent-acknowledged';

// Blok 4, Týž. 17 — transparentnosť ohľadom cookies (GDPR/ePrivacy). Používame len
// nutné funkčné cookies (session), takže právne nejde o "consent" v zmysle voliteľných
// trackovacích cookies (tie nepoužívame), ale banner s informáciou a potvrdením je
// dobrá prax a bol explicitne požadovaný.
export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  if (!visible) return null;

  function acknowledge(): void {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  }

  return (
    <div
      className="no-print"
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 100,
        background: 'var(--bg-raised)',
        borderTop: '1px solid var(--line)',
        boxShadow: 'var(--shadow-md)',
        padding: '14px 20px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '0.9rem',
        justifyContent: 'center',
      }}
    >
      <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--slate)', maxWidth: 560 }}>
        Používame len nutný funkčný cookie na prihlásenie — žiadne reklamné ani sledovacie cookies
        tretích strán.{' '}
        <Link to="/ochrana-udajov" style={{ color: 'var(--brand)' }}>
          Viac o ochrane údajov
        </Link>
        .
      </p>
      <button
        type="button"
        onClick={acknowledge}
        style={{
          padding: '0.5rem 1.2rem',
          border: 'none',
          background: 'var(--brand)',
          color: '#ffffff',
          borderRadius: 8,
          fontSize: '0.85rem',
          fontWeight: 500,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        Rozumiem
      </button>
    </div>
  );
}
